import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataLoaderService } from '../service/data.loader.service';

@Injectable({
  providedIn: 'root',
})
export class RethinkingInsuranceGuard {
  private router = inject(Router);
  private dataLoaderService = inject(DataLoaderService);

  canActivate(): Observable<boolean | UrlTree> {
    // DataLoader/SharedFunctionService's requiredData isn't populated yet during the initial navigation
    // on a hard refresh / direct link, so fetch the flag straight from the required-data json file instead
    // of depending on the app's own load timing.
    return this.dataLoaderService
      .loadRequiredJsonFile()
      .pipe(map((requiredData) => (requiredData?.ShowRethinkingInsurancePage === false ? this.router.createUrlTree(['/home']) : true)));
  }
}
